export default "__VITE_ASSET__LcmKXDBn__"